module.exports = __webpack_public_path__ + "img/frame (185).c2f5177d.jpg";